import { useSearchParams } from 'react-router-dom';

export default function useQuery() {
	const [searchParams, setSearchParams] = useSearchParams();
	return [searchParams, setSearchParams];
}
